// extracted by mini-css-extract-plugin
export var standaloneTable = "_k5-0";
export var standaloneTableWithBodyFill = "_k5-1";
export var withExtraHeader = "_k5-2";